// src/pages/Users.jsx
import React, { useState, useEffect } from "react";
import * as API from "../api";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState("");

  useEffect(() => {
    fetchUsers();
  }, []);

  async function fetchUsers() {
    try {
      const data = await API.getUsers();
      setUsers(data);
    } catch (err) {
      console.error(err);
      alert("خطا در دریافت کاربران");
    }
  }

  async function handleAddUser() {
    if (!newUser.trim()) return alert("نام کاربر را وارد کنید");
    try {
      await API.addUser({ name: newUser });
      setNewUser("");
      fetchUsers();
    } catch {
      alert("خطا در افزودن کاربر");
    }
  }

  async function handleDeleteUser(id) {
    if (window.confirm("آیا از حذف این کاربر مطمئن هستید؟")) {
      try {
        await API.deleteUser(id);
        fetchUsers();
      } catch {
        alert("خطا در حذف کاربر");
      }
    }
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">مدیریت کاربران</h2>
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          value={newUser}
          onChange={(e) => setNewUser(e.target.value)}
          placeholder="نام کاربر جدید"
          className="border p-2 rounded w-64"
        />
        <button
          onClick={handleAddUser}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          افزودن
        </button>
      </div>

      <table className="w-full border">
        <thead>
          <tr className="bg-gray-200 text-right">
            <th className="p-2">نام کاربر</th>
            <th className="p-2">عملیات</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} className="border-t">
              <td className="p-2">{user.name}</td>
              <td className="p-2">
                <button
                  onClick={() => handleDeleteUser(user.id)}
                  className="bg-red-500 text-white px-3 py-1 rounded"
                >
                  حذف
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
